export default __webpack_public_path__ + "static/media/5_galeria.78c20d99.webp";